/**
 * Onboarding funnel tracker — fires a single lifecycle event to
 * /api/analytics/onboarding-event. Backend is idempotent per
 * (user_id, event), so extra fires from re-mounts are harmless.
 *
 * Client-side de-dup layer (sessionStorage) skips network calls we
 * know will be no-ops to keep the funnel logic invisible to users.
 */

import api from "@/lib/api";

const LS_PREFIX = "pfo_onb_fired_v1_";

const KNOWN_EVENTS = new Set([
  "empty_cta_seeded",
  "empty_cta_add_expense",
  "first_expense",
  "first_view_reports",
  "first_view_optimizer",
  "first_view_advisor",
]);

export function trackOnboarding(event) {
  if (!KNOWN_EVENTS.has(event)) return;
  try {
    if (sessionStorage.getItem(LS_PREFIX + event) === "1") return;
    sessionStorage.setItem(LS_PREFIX + event, "1");
  } catch { /* private mode etc. — best-effort */ }
  // Fire-and-forget; failures are non-fatal for the user.
  api.post("/analytics/onboarding-event", null, {
    params: { event },
  }).catch(() => { /* silent */ });
}
